

const ConnectivitySidebar = ({ 
  promoBanners, 
  showPromoBanner, 
}) => {
  return (
    <div className="space-y-8">
      {/* Promotional Banners (Sidebar Card) */}
      {showPromoBanner && promoBanners.length > 0 && (
        <div className="space-y-4">
          {promoBanners.map((banner) => (
            <div
              key={banner.id}
              className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-300 transition-all hover:shadow-md flex flex-col"
            >
              <div className="w-full overflow-hidden bg-slate-50
  aspect-[3/1] md:aspect-[16/9]">

                {banner.banner_type === "image_cta" && banner.image_url ? (
                  <img
                    src={banner.image_url}
                    alt={banner.title}
                    className="w-full h-full object-cover"
                  />
                ) : (
                    <div className="p-3 md:p-6 flex items-center justify-center h-full">
                      <div className="text-center">
                        <h4 className="font-bold text-slate-800 text-sm line-clamp-1">
                          {banner.title}
                        </h4>
                        <div className="hidden md:block text-[11px] text-slate-500
          mt-1 line-clamp-2 prose prose-xs"
                          dangerouslySetInnerHTML={{ __html: banner.description }}
                        />
                      </div>
                  </div>
                )}
              </div>

              <div className="px-3 py-2 flex items-center justify-center border-t border-slate-100">
                <a
                  href={banner.button_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="site-color-btn"
                >
                  {banner.button_text || "Learn More"}
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConnectivitySidebar;
